import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import "./Checkout.css";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

//const stripePromise = loadStripe('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');
//const stripePromise = loadStripe('pk_live_51LrKkPDkX74vtbe5pZ5OXpfjUqErrPRWIWLvir3dZgnddKPmpmvqITbo8cbqVs7wQWpTdu57FWY3z1Wk8OZyOjlf00J5tfBFEZ');

const Checkout = () => {
  const [zipCode, setZipCode] = useState(localStorage.getItem("zipCode") || "");
  const [ville, setVille] = useState(localStorage.getItem("ville") || "");
  const [reference, setReference] = useState(localStorage.getItem("reference") || "");
  const [nom, setNom] = useState(localStorage.getItem("nom") || "");
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [telephone, setTelephone] = useState(localStorage.getItem("telephone") || "");
  const [adresse, setAdresse] = useState(localStorage.getItem("adresse") || "");
  const [codePostal, setCodePostal] = useState(localStorage.getItem("codePostal") || "");
  const [pays, setPays] = useState(localStorage.getItem("pays") || "France");
  const [pointRelais, setPointRelais] = useState("");

  const [cgvAccepted, setCgvAccepted] = useState(false);
  const [showCgvError, setShowCgvError] = useState(false);


  const [errorMessage, setErrorMessage] = useState("");
  const [selectedPointRelais, setSelectedPointRelais] = useState("");
  const [pointsRelais, setPointsRelais] = useState([]);
  const [montant, setMontant] = useState("");
  const [step, setStep] = useState(1);

  const fraisLivraisonDejaPayes = localStorage.getItem("fraisLivraisonPayes") === "true";

  useEffect(() => {
    localStorage.setItem("reference", reference);
  }, [reference]);

  useEffect(() => {
    localStorage.setItem("nom", nom);
  }, [nom]);

  useEffect(() => {
    localStorage.setItem("email", email);
  }, [email]);

  useEffect(() => {
    localStorage.setItem("telephone", telephone);
  }, [telephone]);

  useEffect(() => {
    localStorage.setItem("adresse", adresse);
  }, [adresse]);

  useEffect(() => {
    localStorage.setItem("codePostal", codePostal);
  }, [codePostal]);

  useEffect(() => {
    localStorage.setItem("pays", pays);
  }, [pays]);

  useEffect(() => {
    localStorage.setItem("zipCode", zipCode);
  }, [zipCode]);

  useEffect(() => {
    localStorage.setItem("ville", ville);
  }, [ville]);

  const handleSearchRelais = async () => {
    if (!zipCode || !ville) {
      setErrorMessage("Veuillez renseigner un code postal et une ville.");
      return;
    }
    setErrorMessage("");
  
    try {
      const response = await fetch("https://b-zpro-api-2.vercel.app/api/mondial-relay", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ zipCode, ville }),
      });
  
      const data = await response.json();
  
      if (data.STAT === "0") {
        const relais = Object.values(data).slice(1); // On enlève le champ STAT
        if (relais.length === 0) {
          setErrorMessage("Aucun point Mondial Relay n'a été trouvé près de chez vous");
        } else {
          setPointsRelais(relais);
          setErrorMessage(""); // ✅ Clear l'erreur
        }
      } else {
        setErrorMessage("Erreur de recherche Mondial Relay.");
      }
    } catch (error) {
      setErrorMessage("Erreur lors de la récupération des points relais.");
    }
  };
  

  const handleContinueToPayment = () => {
    if (!selectedPointRelais) {
      setErrorMessage("Veuillez sélectionner un point relais avant de continuer.");
      return;
    }
    setErrorMessage("");
    setStep(3);
  };

  const produitTotal = parseFloat(montant || 0);
  const fraisLivraison = fraisLivraisonDejaPayes ? 0 : 6;



  return (
    <div className="checkout-container">
      <h2>Étape 1. Saisir le montant</h2>
      <div className="montant-container">
        <input
          type="number"
          min="1"
          value={montant}
          onChange={(e) => setMontant(e.target.value)}
          className="montant-input"
        />
        <span className="euro-symbol">€</span>
        <button className="valider-btn" onClick={() => setStep(2)}>
          Valider
        </button>
      </div>

      {step >= 2 && (
        <>
          <h2>Étape 2. Remplir les informations de livraison.</h2>

          <div className="form-row">
            <input type="text" placeholder="Référence" value={reference} onChange={(e) => setReference(e.target.value)} />
            <input type="text" placeholder="Nom" value={nom} onChange={(e) => setNom(e.target.value)} />
          </div>

          <div className="form-row">
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <input type="tel" placeholder="Téléphone" value={telephone} onChange={(e) => setTelephone(e.target.value)} />
            <input type="text" placeholder="Adresse" value={adresse} onChange={(e) => setAdresse(e.target.value)} />
          </div>

          <div className="form-row">
            <input type="text" value={pays} onChange={(e) => setPays(e.target.value)} />
            <input type="text" placeholder="Code Postal" value={zipCode} onChange={(e) => setZipCode(e.target.value)} />
            <input type="text" placeholder="Ville" value={ville} onChange={(e) => setVille(e.target.value)} />
          </div>

          <p className="shipping-info">Merci de saisir un code postal et une ville pour continuer</p>
          <p className="shipping-info">Frais de port facturé une fois lors du premier paiement</p>

          {!fraisLivraisonDejaPayes && (
  <>
    <button
      onClick={handleSearchRelais}
      className="mondial-relay-btn"
      disabled={!zipCode || !ville}
    >
      Mondial Relay (6.00 €)
    </button>

   
   
  </>
)}

          

          <br /><br />
          {errorMessage && <p className="error-message">{errorMessage}</p>}

          {!fraisLivraisonDejaPayes && (
            <div className="point-relais-select-container">
              <select
                value={selectedPointRelais}
                onChange={(e) => setSelectedPointRelais(e.target.value)}
                className="point-relais-select"
              >
                <option value="">Sélectionner un point relais...</option>
                {pointsRelais.map((point, index) => (
                  <option key={index} value={point.Num}>
                    {point.LgAdr1} - {point.LgAdr3}, {point.CP} {point.Ville}
                  </option>
                ))}
              </select>
            </div>
          )}
          <br />
          <div style={{ marginBottom: "10px" }}>
  <label>
    <input
      type="checkbox"
      checked={cgvAccepted}
      onChange={() => {
        setCgvAccepted(!cgvAccepted);
        if (showCgvError) setShowCgvError(false); // masque l'erreur dès qu'on coche
      }}
    />{" "}
    J'accepte <a href="/conditions-generales" target="_blank" rel="noreferrer">conditions générales de ventes</a>
  </label>
  {showCgvError && (
    <p style={{ color: "red", marginTop: "5px" }}>
      Veuillez accepter les termes et conditions
    </p>
  )}
</div>

<button
  onClick={() => {
    if (!cgvAccepted) {
      setShowCgvError(true);
      return;
    }
    handleContinueToPayment(); // ✅ si la case est cochée, continue
  }}
  className="btn continuer-btn"
>
  Continuer vers le paiement
</button>
<br/>
<br/>
<br/>

{showCgvError && (
  <p style={{ color: "red", marginTop: "10px" }}>
  </p>
)}

        </>
      )}

      {step === 3 && (
        <>
          <h3>Étape 3. Mode de paiement.</h3>

          <div className="recap-section">
  <div className="recap-totaux">
    <div>
      <strong>Total produits:</strong>
      <div>{produitTotal.toFixed(2)} €</div>
    </div>
    <div>
      <strong>Total Frais de port:</strong>
      <div>{fraisLivraison.toFixed(2)} €</div>
    </div>
    <div>
      <strong>Total:</strong>
      <div>{(produitTotal + fraisLivraison).toFixed(2)} €</div>
    </div>
  </div>
</div>

<br/>

<div style={{ paddingLeft: "30px" }}>
  <Elements stripe={stripePromise}>
    <CheckoutForm
      montant={montant}
      livraison={{
        reference,
        nom,
        email,
        telephone,
        adresse,
        pays,
        zipCode,
        ville,
        selectedPointRelais, // 👈 AJOUT ICI
      }}
    />
  </Elements>
</div>

<br/>



        </>
      )}
    </div>
  );
};

export default Checkout;